import RoleAssignmentHashTableTypes from "src/pages/hr/Types/RoleAssignmentHashTableTypes"
import roleAssignmentHelper from "./RoleAssignmentHelper"

const handleAddOrDropRole = (bucketItem: RoleAssignmentHashTableTypes, operation?: "+" | "-" | "all" | "!all") => {
    let temp = bucketItem
    let tempAt1 = temp[1]

    if (operation) {

        if (!tempAt1.hasRole && operation === "+") {
            tempAt1.dropRole = false
            tempAt1.addRole = true
            tempAt1.addView = true
        } 
        else if (operation === "-") {
            tempAt1.dropRole = true
            tempAt1.addRole = false
            tempAt1.addView = false
            tempAt1.addEdit = false
        }
        else if (operation === "all") {
            tempAt1.dropRole = false
            tempAt1.addView = false
            tempAt1.addEdit = false
            if (!tempAt1.hasRole) {
                tempAt1.addRole = true
                tempAt1.addView = true
            }
        }
        else if (operation === "!all") {
            tempAt1.dropRole = false
            if (tempAt1.hasRole) {
                tempAt1.dropRole = true
            }
            tempAt1.addRole = false
            tempAt1.addView = false
            tempAt1.addEdit = false
        }

    } else {

        if (tempAt1.hasRole && !tempAt1.dropRole) {
            tempAt1.dropRole = true
        } else if (tempAt1.hasRole && tempAt1.dropRole) {
            tempAt1.dropRole = false
            tempAt1.addView = false
            tempAt1.addEdit = false
        }

        if (!tempAt1.hasRole && !tempAt1.addRole) {
            tempAt1.addRole = true
            tempAt1.addView = true
        } else if (!tempAt1.hasRole && tempAt1.addRole) {
            tempAt1.addRole = false
            tempAt1.addView = false
            tempAt1.addEdit = false
        }
    }

    temp[1] = tempAt1
    roleAssignmentHelper.updateHashTableItem(temp)
    const storage = roleAssignmentHelper.getStorage()
    return storage
}

export default handleAddOrDropRole